import React, { useState, useEffect } from "react";
import axios from "axios";
import MessagesBox from "../MessagesBox";
import SendMessage from "../SendMessage";
import Prescriptions from "./Prescriptions";
import Grid from "@material-ui/core/Grid";

//import "../App.css";

function PatientUI() {
  const [messages, setMessages] = useState([]);
  const [prescriptions, setPrescriptions] = useState([]);
  const [name, setName] = useState(null);


  useEffect(() => {
    const link = `/getMessages/${localStorage.getItem("user")}`;
    axios
      .get(link)
      .then((res) => {
        setMessages(res.data);
      })
      .then(
        axios
          .get(`/getPrescriptions/${localStorage.getItem("user")}`)
          .then((res) => {
            setPrescriptions(res.data);
            console.log(prescriptions);

          })
          .catch((err) => {
            console.log(err);
          })
      )

      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    const link = `/user/${localStorage.getItem("user")}`;
    axios
      .get(link)
      .then((res) => {
        localStorage.setItem("currentProfile", res.data.doctorId);
        setName(res.data.name);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  let myMessagesMarkup = messages ? (
    <MessagesBox messages={messages}></MessagesBox>
  ) : (
      <p>loading</p>
    );

  return (
    <div>
      <h2 style={{ textAlign: 'start', fontWeight: 'normal', paddingLeft: 20}}>
        Logged in as: <b>{name}</b>
      </h2>
      <Grid container style={{ flex: 1 }}>

        <Grid style={{ flex: 1, marginRight: 20, marginLeft: 10 }}>
          <h1>My prescriptions</h1>
          <Prescriptions prescriptions={prescriptions}></Prescriptions>
        </Grid>

        <Grid style={{ flex: 1 }}>
          <div
            style={{
              margin: 10,

            }}
          >
            {myMessagesMarkup}
            <SendMessage
              uid={localStorage.getItem("user")}
            ></SendMessage>
          </div>
        </Grid>

      </Grid>
    </div>
  );
}

export default PatientUI;
